// รหัสรอบ U-<uid>-YYYY-MM-DD-<N> → ภาษาคน "<สาย> · วันที่ · รอบที่ N" (กฎ Vector 10-06: ซ่อนรหัสระบบ ให้กดดูเอา)
// ที่มาของหนี้ "tablet:ROLE:<label บัตร>" → ไม่โชว์สตริงดิบ (ที่มาบอกด้วยป้าย "IMD ส่งเงิน" อยู่แล้ว)
const CODE_RE = /^(.+)-(\d{4}-\d{2}-\d{2})-(\d+)$/;

export const parseReportCode = (code) => {
    const m = CODE_RE.exec(String(code || ''));
    return m ? { sellerUid: m[1], date: m[2], round: Number(m[3]) } : null;
};

// "dd/MM/yyyy" แบบเดียวกับหน้าอื่นของระบบไทย ไม่พึ่ง locale ของเบราว์เซอร์
const thaiDate = (iso) => {
    const [y, mo, d] = iso.split('-');
    return `${d}/${mo}/${y}`;
};

// routeName = ชื่อสาย (ถ้ามี) · parse ไม่ได้ = คืนรหัสดิบเป็นข้อความ (ดีกว่าว่าง)
export const roundLabel = (code, routeName) => {
    if (!code) return '-';
    const p = parseReportCode(code);
    if (!p) return [routeName, String(code)].filter(Boolean).join(' · ');
    return [routeName, thaiDate(p.date), `รอบที่ ${p.round}`].filter(Boolean).join(' · ');
};

// createdBy ของหนี้: tablet:ROLE:label / uid ระบบ = รหัส ไม่โชว์ · ชื่อคนล้วน ๆ โชว์ได้
export const humanCreatedBy = (createdBy) => {
    const s = String(createdBy || '').trim();
    if (!s || /^tablet:/i.test(s) || /^U-[0-9A-F]{6,}$/i.test(s) || /^REC-/i.test(s)) return '';
    return s;
};
